module.exports = __webpack_public_path__ + "media/images/emp-select-280cc7c9b194e3980d7281e8714813b1.png";